import React from 'react';
import { withStyles } from '@mui/styles';
import { Close as CloseIcon } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import concatTokens from '../services/concatTokens.js';
import { colors } from '../theme/index.js';
let variantStyle = false;

/**
 * @param props
 * @returns {*}
 * @constructor
 */
const Chips = props => {
  const {
    classes,
    chipData,
    onDelete,
    variant,
    customStyle,
    id,
    testid
  } = props;
  if (variant) {
    variantStyle = variant;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: id || testid,
    className: `${classes.chipBlock} ${customStyle}`
  }, chipData.length > 0 && chipData.map((chip, i) => /*#__PURE__*/React.createElement(Chip, {
    key: concatTokens(chip, i),
    label: chip,
    color: "primary",
    deleteIcon: /*#__PURE__*/React.createElement(CloseIcon, {
      className: classes.closeChipIcon
    }),
    variant: variant || 'default',
    onDelete: () => onDelete(chip),
    className: `${classes.chip}`
  })));
};

/**
 * @param theme
 */
const styles = theme => ({
  // Todo: Add global styles from UI library
  chipBlock: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  closeChipIcon: {
    color: 'inherit',
    fontSize: '18px',
    '&:hover': {
      filter: 'brightness(75%)'
    }
  },
  chip: {
    color: variantStyle === 'outlined' ? colors.skyBlue : colors.surface,
    margin: '7.5px',
    marginLeft: '2.5px',
    marginRight: '2.5px',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
  }
});
export default withStyles(styles)(Chips);